// @ts-nocheck
import { GetBlogApiParameter } from "@store/Framework/Store/Store/Pages/BlogList/Handlers/GetBlogList";

export default (obj1: GetBlogApiParameter, obj2: GetBlogApiParameter) => {
    if (obj1.sortBy !== obj2.sortBy || obj1.category !== obj2.category || obj1.isArchived !== obj2.isArchived) {
        return false;
    }

    return true;
};
